import { Injectable } from '@angular/core';
import { HttpService } from '@core/services/http.service';
import { MailTemplatePopConfig } from './mail-template-url.config';

@Injectable({
  providedIn: 'root'
})
export class MailTemplateService {
  constructor(private http: HttpService) {
     // This is intentional
  }

  ValidateReferralId(id) {
    return this.http.get(
      MailTemplatePopConfig.EndPoint.Email.ValidateReferral1 +
        id +
        MailTemplatePopConfig.EndPoint.Email.ValidateReferral2
    );
  }
  getPacketListing() {
    return this.http.get(MailTemplatePopConfig.EndPoint.Email.PacketListing);
  }
  mailSent(modal) {
    return this.http.post(MailTemplatePopConfig.EndPoint.Email.Mailattachments, modal);
  }
  getAllEmailTemplateCategories() {
    return this.http.get(MailTemplatePopConfig.EndPoint.Email.GetAllEmailTemplateCategories);
  }
  getEmailTemplateList(id) {
    return this.http.get(MailTemplatePopConfig.EndPoint.Email.GetEmailTemplateList + id);
  }
  getEmailTemplateNewList() {
    return this.http.get(MailTemplatePopConfig.EndPoint.Email.emailtemplateList);
  }
  getReferralSuggestions(searchText) {
    return this.http.get(MailTemplatePopConfig.EndPoint.Email.getReferralSuggestions + searchText);
  }
  mailattachmentsValidation(modal) {
    return this.http.post(MailTemplatePopConfig.EndPoint.Email.mailattachmentsValidation, modal);
  }

  getallPages(id, data) {
    return this.http.post(MailTemplatePopConfig.EndPoint.pages.getAllPages.replace('{orgid}', String(id)), data);
  }

  getResponseSuggesstions(searchText) {
    return this.http.post(MailTemplatePopConfig.EndPoint.pages.responseSuggestions, searchText);
  }
}
